import React            from 'react';

class Arrow extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        let p = this.props;
        return(
            <div className={ `simprakit-dropdown-wrapper-arrow${ p.isOpened ? ' opened' : '' }` }>
                <div className="arrow"></div>
            </div>
        )
    }
}

export default Arrow;